import vue from 'vue'
import Vuex from 'vuex'

vue.use(Vuex)
//视图只允许触发action , action来触发一个或多个（异步）mutation
//state为全局属性
//getter为取属性时的一些操作
import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

export default  new Vuex.Store({
    state,
    getters,
    actions,
    mutations
})



// WEBPACK FOOTER //
// ./src/vuex/index.js